import React from 'react';
import { Eye, LayoutDashboard, LineChart, User } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { buildRoleWorkspaceNavItems } from '../config/roleWorkspaceConfig';
import RoleLayoutShell from './RoleLayoutShell';

const ViewerLayout = () => {
  const auth = useAuth();
  const navItems = buildRoleWorkspaceNavItems('viewer', auth).map((item) => ({
    ...item,
    Icon: item.to === '/profile' ? User : item.to === '/viewer' ? LayoutDashboard : item.to.includes('reports') ? LineChart : Eye,
    anyPermissions: item.permission,
  }));

  return <RoleLayoutShell title="EMS" subtitle="Viewer Workspace" navItems={navItems} />;
};

export default ViewerLayout;
